module.exports = __webpack_public_path__ + "static/heimat-05-ec4ce82c3ec4506a823c9c4fc7987792.jpg";